import React from 'react';
import { useTranslation } from 'react-i18next';
import './PaymentMethods.css';
import ApplePayOption from './ApplePayOption';
import GooglePayOption from './GooglePayOption';
import PaycometJetIframe from './PaycometJetIframe';

const PaymentMethods = ({ amount = '5.00', onSuccess, onError }) => {
  const { t } = useTranslation();
  const currency = 'EUR';

  return (
    <div className="payment-methods">
      <div className="payment-card">
        <div className="payment-header">
          <div className="payment-titles">
            <p className="payment-eyebrow">
              {t('securePayment') || 'Pago seguro'}
            </p>
            <h3>{t('completePurchase') || 'Finaliza tu pedido'}</h3>
          </div>
          <div className="payment-amount-pill">
            <span>{t('total') || 'Total'}</span>
            <strong>EUR {amount}</strong>
          </div>
        </div>

        <div className="payment-tab-content">
          <div className="payment-panel">
            <ApplePayOption
              amount={amount}
              currency={currency}
              description={
                t('applePayDescription') ||
                'Paga rapido y seguro con Apple Pay.'
              }
              onSuccess={onSuccess}
              onError={onError}
            />
            <GooglePayOption
              amount={amount}
              currency={currency}
              description={
                t('googlePayDescription') ||
                'Paga rapido y seguro con Google Pay.'
              }
              dividerLabel={t('orPayWithCard') || 'O pagar con tarjeta'}
              onSuccess={onSuccess}
              onError={onError}
            />
            <p className="payment-copy">
              {t('paymentDescription') ||
                'Completa el pago seguro con PAYCOMET.'}
            </p>
            <PaycometJetIframe
              amount={amount}
              currency={currency}
              onSuccess={onSuccess}
              onError={onError}
            />
          </div>
        </div>

        <p className="payment-secure-note">
          {t('secureWalletNote') ||
            'Apple Pay y Google Pay se muestran cuando son compatibles con tu dispositivo y el pago se procesa de forma segura con Paycomet.'}
        </p>

        <div className="payment-legal-links">
          <a href="/terms" target="_blank" rel="noopener noreferrer">
            {t('terminosDevoluciones') || 'T\u00e9rminos y Devoluciones'}
          </a>
          <span className="payment-legal-divider">{'\u00b7'}</span>
          <a href="/legal" target="_blank" rel="noopener noreferrer">
            {t('avisoLegal') || 'Aviso Legal'}
          </a>
          <span className="payment-legal-divider">{'\u00b7'}</span>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">
            {t('privacyPolicy') || 'Pol\u00edtica de Privacidad'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethods;
